import { FAQItem } from '../../components/FAQItem';
import { SectionWrapper } from '../../components/SectionWrapper';
import { faqs } from './kaiCoachContent';
import { KaiCoachSectionHead } from './KaiCoachSectionHead';

import styles from './KaiCoachFAQSection.module.css';

export function KaiCoachFAQSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-faq-title"
      background="soft"
      data-testid="kai-coach-section-faq"
    >
      <KaiCoachSectionHead
        align="center"
        id="kai-coach-faq-title"
        kicker="Questions"
        title="What faculty and deans ask first"
      />
      <div className={styles.grid}>
        {faqs.map((faq) => (
          <FAQItem key={faq.question} {...faq} />
        ))}
      </div>
    </SectionWrapper>
  );
}
